export default "https://fiverr-res.cloudinary.com/npm-assets/@fiverr/search_perseus/mixing_mastering.8a09dd6.svg";